const doc = [({"en":({"js":({"admin":({"tags":({"workplace_merge_button":({"merge_tags":"Merge tags", "the_tags_were_merged":"The tags were merged."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;